export default {
    name: "production configs",
};
